const BASE_URL = "https://kd9mf8ybeg.execute-api.eu-central-1.amazonaws.com/dev";

export const getBatteries = async () => {
	const res = await fetch(BASE_URL + "/gbuid", { method: "GET" });
	return res.json();
};

export const getBattery = async (id) => {
	const res = await fetch(`${BASE_URL}/gbuid/${id}`);
	if (!res.ok) {
		throw new Error(`HTTP ${res.status}`);
	}
	return res.json();
};

export const createBattery = async (data) => {
	const res = await fetch(BASE_URL + "/gbuid/" + data.gbuid, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(data),
	});
	return res.json();
};

export const deleteBattery = async (id) => {
	const res = await fetch(BASE_URL + "/gbuid/" + id, { method: "DELETE" });
	return res.json();
};
